import React from "react";
import styled from "styled-components";

const HeroSection = styled.section`
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #f8f9fa;
  overflow: hidden;
  padding-top: 80px;
  @media (max-width: 600px) {
    min-height: 70vh;
    padding: 60px 0 16px 0;
    padding-top: 60px;
  }
`;

const GeometricBG = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.13;
  background: url("/logo-pattern.svg") center/contain no-repeat;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
`;

const HeroTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 800;
  color: #222;
  margin-bottom: 18px;
  letter-spacing: 1px;
  @media (max-width: 600px) {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  color: #444;
  margin-bottom: 36px;
  @media (max-width: 600px) {
    font-size: 1rem;
    margin-bottom: 18px;
  }
`;

const CTAButton = styled.button`
  background: #fff;
  color: #222;
  border: 1.5px solid #222;
  padding: 12px 36px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  &:hover {
    background: #222;
    color: #fff;
  }
`;

const Hero = () => (
  <HeroSection id="inicio">
    <GeometricBG />
    <Content>
      <HeroTitle>
        Assessoria Educacional e Organizacional
        <br />
        Dimensões Administrativa e Pedagógica
      </HeroTitle>
      <HeroSubtitle>
        Parceira de confiança, unindo gestão eficiente e práticas
        pedagógicas transformadoras
      </HeroSubtitle>
      <CTAButton
        onClick={() => {
          const element = document.getElementById("sobre");
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }}
      >
        EXPLORE MAIS
      </CTAButton>
    </Content>
  </HeroSection>
);

export default Hero;
